import Vue from 'vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {
  required,
  maxLength,
  minValue
} from "vuelidate/lib/validators";
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import upLoad from '@/assets/img/upload_photo3.jpg';
import axios from 'axios';
import store from "@/store";
import CONFIG from "@/assets/js/config.js";

export default {
  name: "paymentCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      config: CONFIG,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      paymentMethodArr: null,
      inputData: {
        class_id: '',
        student_id: '',
        guardian1_name: '',
        item_id: '',
        discount_type: null,
        discount_amount: null,
        discount_note: '',
        gross_total_amt: 0,
        net_total_amt: 0,
        item_type: '',
      },
      paymentData: {
        class_id: '',
        student_id: '',
        guardian1_name: '',
        discount_type: null,
        discount_amount: null,
        gross_total_amt: 0,
        net_total_amt: 0,
        payment_method_id: '',
        payment_date: new Date().toISOString().split('T')[0],
        enrollment_date: '',
        status: '',
        receiver: this.$store.state.user?.name || '',
        remark: '',
        payment_screenshot: '',
      },
      paymentDetail: [], // Array to store payment details
      editData: [],
      ssImage: '',
      upLoad,
      classArr: [],
      addItem: false,
      submitted: false,
      campusId: store.state.user.campus_id,
      allStu: [],
      isLoading: false,
      disabled: false,
      guardian1Arr: [],
      guardian1Name: '',
      itemArr: [],
      itemId: null,
      visible: false,
      itemAmtArr: [],
      clonedOnce: false,
      disabledForm: false,
      discountPercent: '',
      discountFixAmount: '',
      discountError: '',
      paymentDiscountError: '',
      discountPercentageAmount: 0,
      noregistrationFee: false,
    };
  },

  validations() {
    const isValidDiscount = (value) => {
      const netTotalAmt = this.inputData?.gross_total_amt || 0;
      return (
        value === null ||
        value === undefined ||
        (value >= 0 && value <= netTotalAmt)
      );
    };

    const isValidPaymentDiscount = (value) => {
      const netTotalAmt = this.netTotalSum || 0;
      return (
        value === null ||
        value === undefined ||
        (value >= 0 && value <= netTotalAmt)
      );
    };

    const isInteger = (value) => {
      return value === null || value === undefined || Number.isInteger(value);
    };

    const requiredIfStatusIs1 = (value) => {
      return !(this.paymentData.status == CONFIG.PAYMENT_STATUS.STATUS_APPROVED && (value === null || value === ''));
    };

    return {
      inputData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        item_id: {
          required,
        },
        gross_total_amt: {
          required,
        },
        net_total_amt: {
          required,
        },
        discount_amount: {
          isValidDiscount,
          isInteger,
        },
        discount_note: {
          maxLength: maxLength(1000)
        },
      },
      paymentData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        gross_total_amt: {
          required
        },
        discount_amount: {
          isValidPaymentDiscount,
          isInteger,
        },
        net_total_amt: {
          required,
          minValue: minValue(0)
        },
        payment_method_id: {
          requiredIfStatusIs1
        },
        receiver: {
          requiredIfStatusIs1,
          maxLength: maxLength(100)
        },
        payment_date: {
          requiredIfStatusIs1
        },
        status: {
          required
        },
        remark: {
          maxLength: maxLength(1000)
        },
      }
    };
  },

  methods: {
    resetInputData() {
      const preservedValues = {
        class_id: this.inputData.class_id,
        student_id: this.inputData.student_id,
        guardian1_name: this.inputData.guardian1_name,
      };
      this.inputData = {
        ...preservedValues,
        item_id: '',
        discount_type: null,
        discount_amount: null,
        discount_note: "",
        gross_total_amt: 0,
        net_total_amt: 0,
      };
    },

    getItem() {
      axios.get('item/getItemForPayment')
        .then(res => {
          this.itemArr = res.data.data;
          this.itemAmtArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getAmt(item_id) {
      var selectedItem = this.itemAmtArr.find(item => item.id == item_id);
      this.putTotalAmount(selectedItem.p_item_amount);
    },

    getPaymentMethod() {
      axios.get('getPaymentMethod')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Payment Method'
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data);
          const defaultMethod = res.data.find(
            method => method.text.toLowerCase() == CONFIG.PAYMENT_METHOD.toLowerCase()
          );

          if (defaultMethod) {
            this.paymentData.payment_method_id = defaultMethod.id;
          } else {
            this.paymentData.payment_method_id = 0;
          }
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    calculateNetTotal() {
        let discountAmount = this.inputData.discount_amount || 0;
        this.discountError = "";
        if (discountAmount < 0) {
            this.discountError = "Discount amount cannot be negative.";
            discountAmount = 0;
        }
        if (this.inputData.discount_type == 1) {
            if (this.inputData.gross_total_amt != 0 && discountAmount > this.inputData.gross_total_amt) {
              this.discountError = "Discount amount cannot exceed net total.";
              discountAmount = 0;
            }
            this.inputData.net_total_amt = this.inputData.gross_total_amt - discountAmount;
        } else if (this.inputData.discount_type == 2) {
            if (discountAmount > 100) {
              this.inputData.discount_amount = 100; // Cap discount to 100%
            }
            const discount = (this.inputData.gross_total_amt * discountAmount) / 100;
            this.inputData.net_total_amt = this.inputData.gross_total_amt - discount;
        }
        if (this.inputData.net_total_amt < 0) this.inputData.net_total_amt = 0; // Ensure net total is not negative
    },

    onItemChange() {
        if (!this.inputData.item_id) return;

        this.getAmt(this.inputData.item_id);
        this.calculateNetTotal();
    },

    removeImg() {
      this.ssImage = '';
      document.getElementById('image').value = '';
    },

    getClass() {
      axios.get('class/getGradeAndClass', { 
        params: { 
          campus_id: this.campusId,
          start_date: new Date().toLocaleDateString()
        } 
      })
        .then(res => {
          this.isLoading = false;
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getStudent(id) {
      this.inputData.student_id = null;
      this.inputData.guardian1_name = null;
      axios.get('student/getallStudent', { params: { campus_id: this.campusId, class_id: id } })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select'
          }];
          this.allStu = $defaultSelectOption.concat(res.data);
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getGuardian1Name(id) {
      this.inputData.guardian1_name = null;
      axios.get('student/getGuardian1Name', { params: { campus_id: this.campusId, student_id: id } })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Guardian 1 Name'
          }];
          this.guardian1Arr = $defaultSelectOption.concat(res.data);
          if (res.data.length > 0) {
            this.inputData.guardian1_name = res.data[0].id;
          }
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    imgUpload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return null;
      } else {
        if (e.target.files[0].type.includes("image/")) {
          if (e.target.files[0].type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.onload = (e) => {
            if (e.target.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
            } else {
              this.ssImage = e.target.result;
              document.getElementById('image').value = '';
            }
          }
          reader.readAsDataURL(files[0]);
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    addEditData() {
      this.paymentDetail.push(Vue.util.extend({}, this.editData));
      this.editData = [];
    },

    addData() {
      if (this.editData.item_id) {
        this.paymentDetail.push(Vue.util.extend({}, this.inputData));
      }
    },

    formatDiscountAmount(amount) {
      return amount ? this.$options.filters.numFormat(amount) : '_';
    },

    checkDiscountType(discount_amount, discount_type) {
      if (discount_amount <= 0) {
        return "_";
      }
      return discount_type == 1 ? 'Fixed' : 'Percentage';
    },

    reset() {
      this.addItem = false;
      if (this.editData.item_id != null) {
        this.addEditData();
      }
      if (this.paymentDetail.length == 0) {
        this.getStudent(0);
        this.getGuardian1Name(0);
        this.inputData = {};
      } else {
        this.resetInputData();
      }
    },

    cloneForm() {
      this.editData = [];
      this.addItem = true;
      if (this.$v.inputData.$invalid || this.inputData.student_id == 0 || this.discountError != "" || this.noregistrationFee) {
        return;
      }
      this.cloneData();
    },

    cloneData() {
      if (this.paymentDetail.length < 20) {
        if (this.paymentDetail.length == 0 && !this.clonedOnce) {
          // Only clone once
          this.paymentDetail.push(Vue.util.extend({}, this.inputData));
          const student = this.allStu.find(stu => stu.id == this.inputData.student_id);
          this.paymentData.class_id = this.inputData.class_id;
          this.paymentData.student_id = this.inputData.student_id;
          this.paymentData.student_name = student ? student.text : '';
          this.paymentData.guardian1_name = this.guardian1Arr[1] ? this.guardian1Arr[1].text : '';
          this.disabledForm = true;
          this.clonedOnce = true;
        } else {
          const exists = this.paymentDetail.some(detail => detail.item_id == this.inputData.item_id);
  
          if (!exists) {
            this.paymentDetail.push(Vue.util.extend({}, this.inputData));
          } else {
            this.$notification.error("Payment Item Is Already Exists.", {
              timer: 3,
              position: "bottomCenter"
            });
          }
        }
        this.resetInputData();
      } else {
        alert('Payment can be created at most 20.');
      }
      this.addItem = false;
      this.disabled = false;
    },

    removeClone(index) {
      Vue.delete(this.paymentDetail, index);
      if (this.paymentDetail.length == 0) {
        this.inputData = {
          class_id: '',
          student_id: '',
          guardian1_name: '',
          discount_type: null,
        };
        this.discountPercent = '';
        this.discountPercentageAmount = null;
        this.discountFixAmount = '';
        this.disabledForm = false;
        this.clonedOnce = false;
      }
    },

    editClone(index) {
      this.addData();
      this.getEditData(this.paymentDetail[index]);
      this.inputData = this.paymentDetail[index];
      Vue.delete(this.paymentDetail, index);
    },

    getEditData(data) {
      this.editData.class_id = data.class_id;
      this.editData.student_id = data.student_id;
      this.editData.guardian1_name = data.guardian1_name;
      this.editData.item_id = data.item_id;
      this.editData.discount_type = data.discount_type;
      this.editData.discount_amount = data.discount_amount;
      this.editData.discount_note = data.discount_note;
      this.editData.gross_total_amt = data.gross_total_amt;
      this.editData.net_total_amt = data.net_total_amt;
    },

    submitPayment() {
      this.disabled = true;
      this.submitted = true;
      this.paymentData.gross_total_amt = this.netTotalSum;
      this.paymentData.net_total_amt = this.totalAfterDiscount;
      this.paymentData.payment_screenshot = this.ssImage ? this.ssImage : this.paymentData.payment_screenshot;
      if (this.paymentData.payment_method_id == 0) {
        this.paymentData.payment_method_id = null;
      }

      if(this.paymentDetail.length == 0) {
        this.$notification.error("Payment Item Is Required.", {
          timer: 3,
          position: "bottomCenter"
        });
        this.disabled = false;
        return;
      }

      if (this.submitted && this.$v.paymentData.$invalid) {
        this.disabled = false;
        return;
      }

      axios.post('payment/create', {
        paymentData: this.paymentData,
        paymentDetail: this.paymentDetail,
        loginId: store.state.user.id,
      })
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Payment Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'paymentList'
            })
          }
          if (res.data.status == 201) {
            this.$notification.error("Payment Already Added to this student.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.disabled = false;
            this.isLoading = false;
          } else {
            this.disabled = false;
            this.errors = res.data.errors;
            this.isLoading = false;
          }
          this.disabled = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.disabled = false;
          this.isLoading = false;
          this.errors = error.response.data.errors;
        })
    },

    back() {
      this.$router.go(-1);
    },

    getTotalPaymentAmount() {
      this.noregistrationFee = false;

      const isSelectedItemAndClass = Number(this.inputData.item_id) && Number(this.inputData.class_id);

      if (isSelectedItemAndClass) {
        const gradeFee = this.classArr.find(cls => cls.id == this.inputData.class_id)?.total_grade_fee;

        if (this.inputData.item_type === this.config.PAYMENT_ITEM_TYPE.GRADE_FEE) {
          if (!gradeFee) this.noregistrationFee = true;
          this.putTotalAmount(gradeFee ?? 0);
          return;
        }
      }

      this.onItemChange();
    },

    putTotalAmount(amount) {
      this.inputData.net_total_amt = amount;
      this.inputData.gross_total_amt = amount;
    }
  },

  watch: {
    discountPercent(val) {
      if (val !== '') {
          this.discountFixAmount = '';
      } else {
          this.discountPercentageAmount = 0;
      }
    },
    discountFixAmount(val) {
        if (val !== '') {
            this.discountPercent = '';
        }
    },
    'paymentData.status'(newVal) {
      if (newVal == CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST) {
        this.paymentData.payment_date = null;
      }
    },
    'inputData.discount_type'() {
      this.inputData.discount_amount = null;
      this.inputData.net_total_amt = this.inputData.gross_total_amt;
      this.discountError = "";
    },
    'inputData.item_id'() {
      this.inputData.item_type = this.itemArr.find(item => item.id == this.inputData.item_id)?.item_type;
      this.getTotalPaymentAmount();
    },
    'inputData.class_id'() {
      this.getTotalPaymentAmount();
    }
 },

 computed: {
    netTotalSum() {
      return this.paymentDetail.reduce((sum, item) => sum + (parseFloat(item.net_total_amt) || 0), 0);
    },
    totalAfterDiscount() {
      this.paymentDiscountError = '';
      if(this.discountPercent < 0 || this.discountFixAmount <0 ) {
        this.paymentDiscountError = "Discount amount cannot be negative.";
      }

      if (this.discountPercent) {
        if (this.discountPercent > 100) {
          this.discountPercent = 100; // Cap discount to 100%
        }
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 2;
        this.paymentData.discount_amount = Number(this.discountPercent);
        this.discountPercentageAmount = this.netTotalSum * this.discountPercent / 100;
        return this.netTotalSum -  this.discountPercentageAmount;
      } else if (this.discountFixAmount) {
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 1;
        this.paymentData.discount_amount = Number(this.discountFixAmount);
        return this.netTotalSum - this.discountFixAmount;
      } else {
        this.paymentData.is_discount = 0;
        this.paymentData.discount_type = null;
        this.paymentData.discount_amount = null;
        return this.netTotalSum;
      }
    },
    paymentOptions() {
      return CONFIG.PAYMENT_STATUSES_OPTIONS.filter(opt =>[
          CONFIG.PAYMENT_STATUS.STATUS_APPROVED, 
          CONFIG.PAYMENT_STATUS.STATUS_DECLINED,
          CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST,
        ].includes(opt.id)
      );
    }
  },

  mounted() {
    this.isLoading = true;
    this.getItem();
    this.getClass();
    this.getPaymentMethod();
    if (this.paymentData.length == 0) {
      this.disabled = true;
    }
  },
};
